// ----------------------------------------------------------------------------
// Snippet: Cart JS
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import './ajax-add-cart';